import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

const CusEvalSettingComponent = ({
  register,
  errors,
  fieldName,
  inputCheckKeyDown,
  fields,
  handleResetForm,
  handleDelForm,
  index,
  action = "create",
  isReadOnly,
  evaluateSettingList,
  control,
  rowData,
}) => {
  const { t } = useTranslation();

  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition } = useSortable({
    id: rowData.id,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div ref={setNodeRef} style={style} {...attributes} className="flex items-center justify-center pt-2 gap-2">
      <div className="flex items-center justify-center" style={{ width: "3rem" }}>
        <Button
          type="button"
          className="p-button-icon-only"
          icon="pi pi-bars"
          rounded
          text
          style={{ cursor: "grab" }}
          ref={setActivatorNodeRef}
          {...listeners}
        />
      </div>
      <div className="flex items-center justify-center w-full" style={{ minWidth: "10rem" }}>
        <Controller
          name={`${fieldName}.evaluationId`}
          control={control}
          rules={{ required: { value: true, message: t("validation.required") } }}
          render={({ field, fieldState }) => (
            <Dropdown
              filter
              optionLabel="label"
              optionValue="value"
              value={field.value}
              virtualScrollerOptions={{ itemSize: 40 }}
              defaultValue={""}
              placeholder={t("plz_chs")}
              name={`${fieldName}.evaluationId`}
              control={control}
              options={evaluateSettingList}
              className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
              onChange={(event) => {
                field.onChange(event.value);
              }}
            />
          )}
        />
      </div>
      <div className="flex items-center justify-center" style={{ width: "3rem" }}>
        <Button
          type="button"
          className="p-button-icon-only"
          icon="pi pi-minus"
          rounded
          text
          onClick={() => {
            fields?.length === 1 ? handleResetForm(index) : handleDelForm(index);
          }}
        />
      </div>
    </div>
  );
};

export default CusEvalSettingComponent;
